var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page compaire-page" }, [
    _c("div", { staticClass: "scroll-holder" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "compaire-bar as-flex main-between cross-center" },
      [
        _vm.mainMovieId
          ? _c(
              "div",
              { staticClass: "main-container" },
              [_c("mainMovieBox", { attrs: { mainMovieId: _vm.mainMovieId } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "compaire-cantainer" },
          [
            _c("compaireMoviesBox", {
              attrs: { movieListBriefInfo: _vm.movieListBriefInfo },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter-box as-flex main-start cross-center f-2" },
      [
        _c(
          "div",
          { staticClass: "filter-part as-flex main-start cross-center" },
          [
            _c(
              "div",
              {
                class: [
                  "ordered-item",
                  "time-ordered",
                  _vm.before_after === "before" ? "is-selected" : "",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeBeforeAfter("before")
                  },
                },
              },
              [_vm._v("映前热度")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "ordered-item",
                  "box-ordered",
                  _vm.before_after === "after" ? "is-selected" : "",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeBeforeAfter("after")
                  },
                },
              },
              [_vm._v("映后口碑")]
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "crowd-filter",
                attrs: { value: _vm.crowd.name, placeholder: "请选择人群" },
                on: { change: _vm.changeCurrentCrowd },
              },
              _vm._l(_vm.crowdConfig, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-dropdown",
              {
                class: ["ordered-item", "cycle-filter", "f-2", "as-nowrap"],
                attrs: { trigger: "click" },
              },
              [
                _c("span", { staticClass: "el-dropdown-link" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.cycle.name) + "\n          "
                  ),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _vm._l(_vm.before_after_cycle, function (item, index) {
                      return [
                        _c("el-dropdown-item", { key: "cycle_" + index }, [
                          _c(
                            "div",
                            {
                              staticClass: "as-nowrap",
                              on: {
                                click: function ($event) {
                                  return _vm.changeCurrentCycle(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]),
                      ]
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.userInfo.can_download
          ? _c("div", { staticClass: "download-part" }, [
              _c(
                "div",
                {
                  staticClass: "download-total-btn f-2",
                  on: { click: _vm.downloadTotalData },
                },
                [_vm._v("下载全局数据")]
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    !_vm.has_before_after_flag[_vm.before_after]
      ? _c(
          "div",
          {
            staticClass:
              "chart-box as-flex flex-vertical main-start cross-center",
          },
          [
            _vm._l(_vm.currentIndexArray, function (item) {
              return [
                _c(
                  "div",
                  { key: item.id, staticClass: "graph as-full-width" },
                  [
                    _c("graphContainer", {
                      key: item.id,
                      attrs: {
                        mainMovie: _vm.mainMovieBriefInfo,
                        beforeAfter: _vm.before_after,
                        movieList: _vm.movieListBriefInfo.filter(function (
                          item
                        ) {
                          return _vm.movieActive[item.id] === true
                        }),
                        indexId: item.id,
                        crowd: _vm.crowd,
                        cycle: _vm.cycle,
                      },
                      on: { showTagIntroduction: _vm.showTagIntroduction },
                    }),
                  ],
                  1
                ),
              ]
            }),
          ],
          2
        )
      : _c(
          "div",
          {
            staticClass:
              "has-no-data as-full-height as-full-width as-flex flex-vertical main-center cross-center",
          },
          [
            _c("img", {
              staticClass: "has-no-data-img",
              attrs: {
                src: require("../assets/images/has-no-data-3x.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "has-no-data-tip f-2" }, [
              _vm._v(
                "暂无" +
                  _vm._s(_vm.before_after === "before" ? "映前" : "映后") +
                  "监测数据"
              ),
            ]),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }